import { Button, Input, Modal } from "@components";
import React, { useCallback, useMemo, useState } from "react";
import { ErrorType, User, UserShopRoleEnum } from "@utilities/types";

type createType = { email: string, role: UserShopRoleEnum };

interface CollaboratorModalProps {
    isOpen: boolean;
    isLoading: boolean;
    selectedCollaborator?: User;
    error?: ErrorType | null;
    onClose: () => void;
    onButtonClick: (props: createType | UserShopRoleEnum) => void;
}

export const CollaboratorModal: React.FC<CollaboratorModalProps> = ({
    isOpen,
    isLoading,
    selectedCollaborator,
    error,
    onClose,
    onButtonClick,
}) => {

    const [email, setEmail] = useState<string>("");
    const [role, setRole] = useState<UserShopRoleEnum>(UserShopRoleEnum.seller);

    const modalTitle = useMemo(()=> selectedCollaborator 
        ? "Modifier un collaborateur" : "Ajouter un collaborateur"
    , [selectedCollaborator]);

    const handleButtonClick = useCallback(()=> {
        if (selectedCollaborator) {
            // onButtonClick(selectedCollaborator);
        } else {
            if(email && role){
                onButtonClick({ email, role });
                setEmail("");
                setRole(UserShopRoleEnum.seller);
            }
        }
    }, [ email, role, selectedCollaborator, onButtonClick ]);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={modalTitle}
        >
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2">
                <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email du collaborateur"
                />

                <Input
                    type="select"
                    value={role}
                    onChange={(e) => setRole(e.target.value as UserShopRoleEnum)}
                    placeholder="Rôle du collaborateur"
                    options={[
                        { value: UserShopRoleEnum.seller, label: "Vendeur" },
                        { value: UserShopRoleEnum.subAdmin, label: "Sous administrateur" },
                        { value: UserShopRoleEnum.admin, label: "Administrateur" },
                    ]}
                />

                {
                    error && (
                        <p className="text-red-500 text-sm mt-2">{error?.message}</p>
                    )
                }

                <div className="modal-action col-span-full flex justify-end">
                    <Button
                        disabled={isLoading}
                        className="btn btn-success rounded-md"
                        onClick={handleButtonClick}
                    >
                        {isLoading ? "Chargement..." : selectedCollaborator ? "Modifier" : "Ajouter"}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
